<template>
  <modal-template
    ref="modal"
    modal-size="lg"
    class="aqui"
    :title="title"
    type-modal="edit_commercial_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">
        <d-form-row class="form-group">
          <d-col cols="4">
            <label>Name</label>
            <d-input v-model="model.user.name" class="form-control" />
          </d-col>
          <d-col cols="4">
            <label>E-mail</label>
            <d-input v-model="model.user.email" class="form-control" />
          </d-col>
          <d-col cols="4">
            <label>Telefone</label>
            <input-phone
              id="feTelefone"
              placeholder="Telefone"
              :model.sync="model.phone"
            ></input-phone>
          </d-col>
        </d-form-row>
        <d-form-row class="form-group">
          <h6 class="px-1">Lista de Representantes</h6>
          <d-list-group flush class="list-group-small col-12">
            <d-list-group-item v-for="(user, index) in model.representatives" :key="user.id" class="d-flex py-2 px-0">
              <d-row class="w-100 align-items-center">
                <d-col cols="10">{{ user.name }}</d-col>
                <d-col cols="2 pr-0 text-right">
                  <d-button size="sm" class="btn-danger" @click.prevent="detachUser(index)">Delete</d-button>
                </d-col>
              </d-row>
            </d-list-group-item>
            <d-list-group-item class="d-flex py-2 px-0">
              <autocomplete
                ref="representative"
                placeholder="Representante"
                item-show="name"
                :items="representatives"
                :on-input="onInput"
                :on-select="setRepresentative"
                clearInput
              ></autocomplete>
            </d-list-group-item>
          </d-list-group>
        </d-form-row>
      </d-form>
    </div>
    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-4"
      >Cancelar</d-button>
      <d-button
        type="submit"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import ModalTemplate from '_shared/Modal.vue';
import InputPhone from '_shared/InputPhone.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import CommercialService from '_services/rest/modules/commercial';
import RepresentativeService from '_services/rest/modules/representative';
import { MODEL, _EDIT_COMMERCIAL_ } from '../CommercialModel';

export default {
  name: 'commercial-edit-modal',
  components: {
    InputPhone,
    Autocomplete,
    ModalTemplate,
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      searchTimeoutId: null,
      representatives: [],
    };
  },
  computed: {
    title() {
      if (this.model.id) {
        return 'Editar membro';
      }
      return 'Novo membro';
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.model = cloneDeep(MODEL);
      this.setToggle({ type: 'edit_commercial_modal', bool: false });
    },
    onInput(search) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        const params = {
          search,
          skip: 0,
          take: 10,
        };
        RepresentativeService.getList(params)
          .then(response => {
            this.representatives = response.list;
          });
      }, 500);
    },
    setRepresentative(representative) {
      this.model.representatives.push(representative);
      this.representatives = [];
    },
    saveError(error) {
      this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
    },
    save() {
      const close = this.model.id !== null;
      CommercialService.save(this.model)
        .then(response => {
          this.model = response;
          Events.$emit('update:pagination', { page: 1 });
          if (close) {
            this.close();
          } else {
            this.getResellers();
          }
        });
    },
    detachUser(index) {
      this.model.representatives.splice(index, 1);
    },
  },
  mounted() {
    Events.$on(_EDIT_COMMERCIAL_, commercial => {
      this.model = commercial;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
@media (min-width: 992px) {
  /deep/ .modal-lg {
    max-width: 990px;
  }
}
.table {
  .no-content {
    vertical-align: middle;
  }
  .selected {
    background: lighten($cyan, 45%);
  }
  &-sync {
    tr td{
      height: 47px;
    }
  }
}

</style>
